import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Typography } from 'antd';
import { classNames } from 'utils';
import './ProductCard.scss';
import Card from 'ui-kit/Card';
import placeholder from 'components/Dashboard/Store/Products/images/placeholder.png';

export function ProductCardBase({ className, imgSrc, children, onImageClick, onClick }) {
  return (
    <Card className={classNames(className, 'ProductCard')} onClick={onClick}>
      <Avatar className="ProductCard__image" src={imgSrc || placeholder} onClick={onImageClick} />
      {children}
    </Card>
  );
}

ProductCardBase.propTypes = {
  className: PropTypes.string,
  imgSrc: PropTypes.string,
  children: PropTypes.node,
  onImageClick: PropTypes.func,
  onClick: PropTypes.func,
};

ProductCardBase.defaultProps = {
  imgHeight: 230,
};

export default function ProductCard({ title, ...rest }) {
  return (
    <ProductCardBase {...rest}>
      <Typography.Title className="ProductCard_title" level={3}>
        {title}
      </Typography.Title>
    </ProductCardBase>
  );
}

ProductCard.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
};
